// export const loobackApiUrl = "http://localhost:3000/";
export const loobackApiUrl = "https://ukkbwarehouse.com/api";
export const apiUrl = "http://api.ukkbwarehouse.com";


